// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3732":"f5c58c364d2a8194","7795":"887cf23f54ad1bf2"}[chunkId] + ".css";
};